import {Button, Dialog, DialogActions, DialogContent, MenuItem, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import useAppContext from "../../util/AppContext";
import CCInputLabel from "../Common/CCInputLabel";
import CCSelect from "../Common/CCSelect";
import css_shared from "../Login2/css/LoginCommon.module.scss";
import css_nav from "../Navigation/css/NavBar.module.scss";
import axios from "axios";
import parkourImage from "../../assets/ParkourLogo.svg";
import {Blue3} from "../../theme/styles";
import CCPulse from "../Common/CCPulse";
import EventBus from "../../util/EventBus";
import css_buttons from "../Common/css/CCButton.module.scss";
import {postLoginRedirect} from "../../util/postLoginRedirect";
import {accountHoldsPersona} from "../../util/ssoAuthenticate";
import {defaultVisibilityFor} from "./switchAccountPersonas";

export function SwitchAccount() {

    const {sessionContext} = useAppContext();

    // eslint-disable-next-line no-unused-vars
    const [submitting, setSubmitting] = useState(false);

    const [companies, setCompanies] = useState([]);
    const [displayedCompany, setDisplayedCompany] = useState("");
    const [displayedCompanies, setDisplayedCompanies] = useState([]);
    const [displayedVisibility, setDisplayedVisibility] = useState(null);

    useEffect(() => {
        init().then(() => {})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function switchCompany() {
        // @ts-ignore
        axios({
            method: "PUT",
            baseURL: process.env.REACT_APP_API_URL,
            url: "t10/v1/authenticate",
            json: true,
            data: {
                "X-Cres-RefreshToken": sessionContext.getRefreshToken(),
                // AccountUSID, which is what the payload actually carries. It was CompanyUSID --
                // a key no account object has -- so ChangeRealm went as undefined and the server
                // was never told which realm to change to. SWITCH ACCOUNT HAS NOT BEEN SWITCHING
                // ACCOUNTS: the call succeeded, the page reloaded, and the session stayed where it
                // was. Reported against t6 by Ed, 2026-10-18; every app carried it.
                "ChangeRealm": companies[displayedCompany]["AccountUSID"],
                "Visibility": displayedVisibility
            },
        }).then(response => {
            let visibilityMode, visibilityValue
            // THE SAME RULE AS LOGIN, and this is the screen where it matters most: switching
            // ACCOUNT is precisely when a persona from the account being left stops being held.
            // Adopting it anyway leaves every read refused CC-PRSN-DENY at 403.
            const chosen = displayedVisibility ? displayedVisibility.split(":") : [];
            if (chosen.length === 3 && accountHoldsPersona(response.data["Account"], chosen[2])) {
                [, visibilityMode, visibilityValue] = chosen;
            } else {
                visibilityMode = "Position"
                visibilityValue = response.data["Account"]["Positions"][0].USID
            }

            sessionContext.setActiveVisibility(visibilityMode, visibilityValue)
            sessionContext.setIdentityToken(response.data["IdentityToken"])
            sessionContext.setSessionUSID(response.data["Session"])
            sessionContext.setAccessToken(response.data["AccessToken"])
            sessionContext.setRefreshToken(response.data["RefreshToken"])
            sessionContext.setAccountName(response.data["Account"]["AccountName"])
            sessionContext.setAccountUserUSID(response.data["Account"]["AccountUserUSID"])
            sessionContext.setAccount(response.data["Account"])
            sessionContext.setRoles(response.data["Roles"])
            sessionContext.setPrivileges(response.data["Privileges"])
            sessionContext.setProducts(response.data["Products"] || [])
            sessionContext.setPrivilegeConstraints(response.data["PrivilegeConstraints"])
            sessionContext.setTenants(response.data["Tenants"])
            sessionContext.setShowLoginDialog(false)
            sessionContext.setPickValues(response.data["PickValues"])
            sessionContext.setS3AccessKeyId(response.data["S3AccessKeyId"])
            sessionContext.setS3SecretAccessKey(response.data["S3SecretAccessKey"])
            sessionContext.setS3SessionToken(response.data["S3SessionToken"])

            window.location.href = postLoginRedirect();
        }).catch(() => {
            EventBus.error.emit("show-system-error");
        });
    }

    async function login() {
        return await axios({
            method: "PUT",
            baseURL: process.env.REACT_APP_API_URL,
            url: "t10/v1/authenticate",
            json: true,
            headers: {},
            data: {
                "X-Cres-RefreshToken": sessionContext.getRefreshToken(),
                "SwitchAccount": true
            }
        }).catch(e => e.response || e);
    }

    async function init() {
        let result = await login();

        const companies = result.data["Accounts"];

        const displayedCompanies = Object.keys(companies).sort();
        const displayedCompany = displayedCompanies[0];
        const displayedVisibility = defaultVisibilityFor(companies, displayedCompany);

        setCompanies(companies);

        setDisplayedCompany(displayedCompany);
        setDisplayedCompanies(displayedCompanies);
        setDisplayedVisibility(displayedVisibility);
    }

    let loginFormToPresent = null;

    if (displayedCompanies.length >= 1) {
        loginFormToPresent = (
            <>
                <Typography className={css_shared.Title}>Select your account</Typography>
                <CCInputLabel>Account</CCInputLabel>
                <CCSelect
                    size={"small"}
                    fullWidth={true}
                    value={displayedCompany}
                    onChange={e => {
                        setDisplayedCompany(e.target.value);
                        setDisplayedVisibility(defaultVisibilityFor(companies, e.target.value));
                    }}
                >
                    {displayedCompanies.map(account => (
                        <MenuItem value={account} key={`select-account-${account}`}>{account}</MenuItem>
                    ))}
                </CCSelect>
                <Button
                    className={css_buttons.blueStandardButton}
                    style={{width: "100%", marginTop: "20px", marginBottom: "5px"}}
                    disabled={submitting || !displayedCompany}
                    onClick={() => {
                        switchCompany();
                    }}>
                    <span style={{visibility: submitting ? "hidden" : "visible"}}>
                        Select
                    </span>
                    {submitting && <CCPulse className={css_buttons.Pulse}/>}
                </Button>
            </>
        );
    }

    return (
        <Dialog maxWidth="md" open={true} scroll="body">
            <DialogContent style={{padding: "0 16px"}}>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>
                    <div key={1} style={{paddingTop: "0px", paddingRight: "2px", marginLeft: "-5px"}}><img className={css_nav.ParkourLogo} src={parkourImage} alt="Home"/></div>
                    <div key={2} style={{paddingTop: "5px", marginLeft: "57px", marginRight: "4px"}}><Typography style={{fontSize: 24, fontWeight: 400, color: Blue3}}>|</Typography></div>
                    <div key={3} style={{paddingTop: "7px"}}><Typography style={{fontSize: 24, fontWeight: 400, color: Blue3}}>&nbsp;&nbsp;ParkourAI</Typography></div>
                </div>
                {loginFormToPresent}
            </DialogContent>
            <DialogActions>
            </DialogActions>
        </Dialog>
    );

}
